module.exports = __webpack_public_path__ + "static/MasterBath2-f86f5598fcb4c24e6341ed5831beb50c.jpg";